import './panelHeader.css'

const PanelHeader = ({title, underline = true}) =>
    (underline ? <h6 className="hr">{title}</h6> : <h6 style={{margin:0}}>{title}</h6>)

export default PanelHeader;